import './App.css';
import React from 'react'
import RadarChart from './components/RadarChart.js'
import AppForm from './components/AppForm.js'
import Popup from './components/Popup.js'

function App() {
  
  const [showPopup, setShowPopup] = React.useState({
    show: false,
    type: "",
  });

  function handleTogglePopup(value) {
    setShowPopup(value);
  }

  return (
    <div className="App">
      <div className="App--header-design">
      </div>
      <AppForm
        handleTogglePopup={handleTogglePopup}
      />
      {showPopup.show && <Popup
        handleTogglePopup={handleTogglePopup}
        type={showPopup.type}
      />}
    </div>
  );
}

export default App;
